import React, { useEffect, useMemo, useState } from "react";
import { TextHeader } from "components/Texts";
import { useDispatch, useSelector } from "react-redux";

import Section from "components/Section";
import Button from "components/Buttons";
import Toast from "components/Toast";
import Modal from "components/gads/Modal";
import ToggleSwitch from "components/ToggleSwitch";
import GoogleAdsOfflineConversionWidget from "components/gads/OfflineConversionWidget";
import GoogleAdsOfflineConversionCrm from "components/gads/OfflineConversionCrm";
import GoogleAdsOfflineConversionSheets from "components/gads/OfflineConversionSheets";
import Loading from "components/gads/Loading";
import styled from "styled-components";
import googleActions from "modules/google/actions";
import googleSelectors from "modules/google/selectors";
import { useTranslation } from "react-i18next";
import mainSelectors from "modules/main/selectors";

const OfflineConversion = () => {
  const { REACT_APP_ENABLE_GOOGLE, REACT_APP_ENABLE_GOOGLE_WHITELIST } = process.env;
  const rmpToken = sessionStorage.getItem("rmp_token");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("r-widget");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [modalActiveConversionDisplay, setModalActiveConversionDisplay] = useState("hide");
  const [modalInactiveConversionDisplay, setModalInactiveConversionDisplay] = useState("hide");
  const [conversionStatusLoading, setConversionStatusLoading] = useState(false);
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));
  const accountDataResult = useSelector((state) => googleSelectors.getAccountDataResult(state));
  const offlineConversionAddonResult = useSelector((state) => googleSelectors.getOfflineConversionAddonResult(state));
  const updateOfflineConversionAddonResult = useSelector((state) =>
    googleSelectors.updateOfflineConversionAddonResult(state),
  );
  const setSyncedOfflineConversionsResult = useSelector((state) =>
    googleSelectors.setSyncedOfflineConversionsResult(state),
  );
  const menu = "google_ads_offline_conversion";
  //eslint-disable-next-line no-unused-vars
  const RcrmAppAvailableResult = useSelector((state) => mainSelectors.checkAppAvailableResult(state));
  const [t, i18n] = useTranslation();

  const RenderContent = useMemo(() => {
    if (currentTab === "r-widget") {
      return <GoogleAdsOfflineConversionWidget />;
    } else if (currentTab === "r-crm") {
      return <GoogleAdsOfflineConversionCrm />;
    } else if (
      currentTab === "g-sheets" &&
      (REACT_APP_ENABLE_GOOGLE == "TRUE" ||
        (businessInfoResult?.data?.business_id &&
          REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0))
    ) {
      return <GoogleAdsOfflineConversionSheets />;
    }
  }, [currentTab]);

  const changeCurrentTab = (tab) => {
    setCurrentTab(tab);
    if (tab === "g-sheets") {
      dispatch(
        googleActions.getGoogleSheetsOfflineConversionsValue({
          token: rmpToken,
        }),
      );
      dispatch(
        googleActions.getGoogleSheetsOfflineConversionsLastSent({
          token: rmpToken,
        }),
      );
    }
  };

  const handleLoading = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu")) {
      setLoading(value);
    }
  };

  useEffect(() => {
    dispatch(
      googleActions.getOfflineConversionAddon({
        token: rmpToken,
      }),
    );
  }, [updateOfflineConversionAddonResult]);

  useEffect(() => {
    if (businessInfoResult.data.business_id && accountDataResult.result !== 0) {
      getAccountData();
    }
  }, [businessInfoResult]);

  const getAccountData = async () => {
    await dispatch(
      googleActions.getAccountData({
        token: rmpToken,
        business_id: businessInfoResult.data.business_id,
        agency_id: businessInfoResult.data.agency_id,
        adwords_id: businessInfoResult.data.adwords_id,
      }),
    );
  };

  useMemo(async () => {
    if (
      accountDataResult.result === 0 &&
      offlineConversionAddonResult.data.status === "active" &&
      setSyncedOfflineConversionsResult.data &&
      setSyncedOfflineConversionsResult.data.synced !== true &&
      setSyncedOfflineConversionsResult.data.synced !== "processing"
    ) {
      handleLoading(true);
      dispatch(googleActions.setSyncedOfflineConversions("processing"));
      const lang = sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en";

      const getAdwordsConversionsData = await dispatch(
        googleActions.getAdwordsConversionsData({
          token: rmpToken,
          business_plan: businessInfoResult.data.business_plan_category,
        }),
      );

      // Loop create Offline Conversion from getAdwordsConversionsData
      // for (let i = 0; i < getAdwordsConversionsData.data.length; i += 1) {
      //   if (getAdwordsConversionsData.data[i].feature_name &&
      //     (
      //       getAdwordsConversionsData.data[i].lead_status_id ||
      //       getAdwordsConversionsData.data[i].lead_status_id == "0"
      //     ) &&
      //     getAdwordsConversionsData.data[i].conversion_name
      //   ) {
      //     dispatch(googleActions.createOfflineConversion({
      //       token: rmpToken,
      //       business_id: businessInfoResult.data.business_id,
      //       adwords_id: accountDataResult.adwords_id,
      //       agency_id: businessInfoResult.data.agency_id,
      //       lead_status_id: getAdwordsConversionsData.data[i].lead_status_id, // conversions_data
      //       conversion_name: getAdwordsConversionsData.data[i].conversion_name, // conversions_data
      //       conversion_id: getAdwordsConversionsData.data[i].conversion_id, // conversions_data
      //       feature_name: getAdwordsConversionsData.data[i].feature_name, // conversions_data
      //       lang,
      //     }))
      //   }
      // }

      await dispatch(
        googleActions.getAdwordsConversionsLastsend({
          token: rmpToken,
          lang,
        }),
      );

      dispatch(googleActions.setSyncedOfflineConversions(true));
      handleLoading(false);
    } else if (setSyncedOfflineConversionsResult.data.synced !== "processing") {
      handleLoading(false);
    }
  }, [accountDataResult, offlineConversionAddonResult, setSyncedOfflineConversionsResult]);

  const handleActiveConversionCloseModal = () => {
    setModalActiveConversionDisplay("hide");
  };

  const handleInactiveConversionCloseModal = () => {
    setModalInactiveConversionDisplay("hide");
  };

  const handleClickActiveLeadConversion = (event) => {
    event.preventDefault();

    if (offlineConversionAddonResult.data.status === "active") {
      setModalInactiveConversionDisplay("show");
    } else {
      setModalActiveConversionDisplay("show");
    }
  };

  const handleActiveConversion = async () => {
    setConversionStatusLoading(true);
    const response = await dispatch(
      googleActions.updateOfflineConversionAddon({
        token: rmpToken,
        smartAdsStatus: "on",
      }),
    );

    if (response.result === 0) {
      setShowSuccessToast(true);
    } else {
      setShowFailedToast(true);
    }

    setModalActiveConversionDisplay("hide");
    setConversionStatusLoading(false);
  };

  const handleInactiveConversion = async () => {
    setConversionStatusLoading(true);
    const response = await dispatch(
      googleActions.updateOfflineConversionAddon({
        token: rmpToken,
        smartAdsStatus: "off",
      }),
    );

    if (response.result === 0) {
      setShowSuccessToast(true);
    } else {
      setShowFailedToast(true);
    }

    setModalInactiveConversionDisplay("hide");
    setConversionStatusLoading(false);
  };

  const handleChangeActiveLeadConversion = () => {
    // Do nothing
  };

  const successToastCallback = (value) => {
    setShowSuccessToast(value);
  };

  const failedToastCallback = (value) => {
    setShowFailedToast(value);
  };

  const modalActiveConversionContent = (
    <ModalContentContainer>
      <div className="info-icon">&#9432;</div>
      <div>{t("__ads_offline_conversion_active_confirm")}</div>
    </ModalContentContainer>
  );

  const modalActiveConversionFooter = (
    <ModalButtonContainer>
      <Button type="secondary" onClick={handleActiveConversionCloseModal}>
        {t("__ads_offline_conversion_cancel_button")}
      </Button>
      <Button type="loading" onClick={handleActiveConversion} loading={conversionStatusLoading}>
        {t("__ads_offline_conversion_confirm_button")}
      </Button>
    </ModalButtonContainer>
  );
  const modalInactiveConversionContent = (
    <ModalContentContainer>
      <div className="info-icon">&#9432;</div>
      <div>{t("__ads_offline_conversion_inactive_confirm")}</div>
    </ModalContentContainer>
  );
  const modalInactiveConversionFooter = (
    <ModalButtonContainer>
      <Button type="secondary" onClick={handleInactiveConversionCloseModal}>
        {t("__ads_offline_conversion_cancel_button")}
      </Button>
      <Button type="loading" onClick={handleInactiveConversion} loading={conversionStatusLoading}>
        {t("__ads_offline_conversion_confirm_button")}
      </Button>
    </ModalButtonContainer>
  );

  return (
    <>
      <SetupTextHeader>{t("__ads_offline_conversion_title")}</SetupTextHeader>

      <ConversionSettingsContainer>
        <FlexSpaceBetween>
          <ConversionStatusLabel>{t("__ads_offline_conversion_sync")}</ConversionStatusLabel>
          <div>
            <ToggleSwitch
              value="on"
              checked={offlineConversionAddonResult.data.status === "active"}
              onClick={(event) => handleClickActiveLeadConversion(event)}
              onChange={handleChangeActiveLeadConversion}
            ></ToggleSwitch>
          </div>
        </FlexSpaceBetween>
        <FlexCenter>
          <div>
            <ConnectionImage
              src={
                offlineConversionAddonResult.data.status === "active"
                  ? "/images/google_connected.png"
                  : "/images/google_disconnected.png"
              }
            />
          </div>
        </FlexCenter>
      </ConversionSettingsContainer>

      {offlineConversionAddonResult.data.status === "active" ? (
        loading === true ? (
          <Loading />
        ) : (
          <div>
            <Tabs>
              <TabPanel
                className={currentTab === "r-widget" ? "selected" : ""}
                onClick={() => {
                  changeCurrentTab("r-widget");
                }}
              >
                R-Widget
              </TabPanel>
              {RcrmAppAvailableResult &&
              RcrmAppAvailableResult.result === 0 &&
              RcrmAppAvailableResult.data &&
              RcrmAppAvailableResult.data.foundApp ? (
                <TabPanel
                  className={currentTab === "r-crm" ? "selected" : ""}
                  onClick={() => {
                    changeCurrentTab("r-crm");
                  }}
                >
                  R-CRM
                </TabPanel>
              ) : (
                ""
              )}
              {(REACT_APP_ENABLE_GOOGLE == "TRUE" ||
                (businessInfoResult?.data?.business_id &&
                  REACT_APP_ENABLE_GOOGLE_WHITELIST.search(businessInfoResult?.data?.business_id) >= 0)) && (
                <TabPanel
                  className={currentTab === "g-sheets" ? "selected" : ""}
                  onClick={() => {
                    changeCurrentTab("g-sheets");
                  }}
                >
                  Google Sheets
                </TabPanel>
              )}
              <TabDummy></TabDummy>
            </Tabs>
            <div>{RenderContent}</div>
          </div>
        )
      ) : (
        ""
      )}

      <Toast
        show={showSuccessToast}
        message={t("__ads_offline_conversion_save_success")}
        bgColor="#4CAF50"
        callback={successToastCallback}
      ></Toast>
      <Toast
        show={showFailedToast}
        message={t("__ads_offline_conversion_save_failed")}
        bgColor="#F44336"
        callback={failedToastCallback}
      ></Toast>
      <Modal
        state={modalActiveConversionDisplay}
        content={modalActiveConversionContent}
        footer={modalActiveConversionFooter}
      />
      <Modal
        state={modalInactiveConversionDisplay}
        content={modalInactiveConversionContent}
        footer={modalInactiveConversionFooter}
      />
    </>
  );
};

export default OfflineConversion;

const SetupTextHeader = styled(TextHeader)`
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: bold;
`;

const Tabs = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 0px;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

const TabPanel = styled.div`
  min-width: 100px;
  max-width: 50%;
  padding: 10px;
  list-style: none;
  text-align: center;
  cursor: pointer;

  &.selected {
    border-bottom: 2px solid #0088e3;
  }
`;

const TabDummy = styled.div`
  flex-grow: 1;
`;

const StyledLabel = styled.label`
  cursor: pointer;
  vertical-align: middle;
`;

const StyledCheckbox = styled.input`
  cursor: pointer;
  vertical-align: middle;
`;

const ModalContentContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
  color: #575757;
  font-weight: bold;

  .info-icon {
    font-size: 78px;
    color: #f8bb86;
    margin-bottom: 20px;
    font-weight: normal;
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;

  > Button {
    min-width: 100px;
    margin-bottom: 0px;
  }

  > Button:first-child {
    margin-right: 10px;
  }
`;

const ConversionSettingsContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 20px;
`;

const FlexSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConnectionImage = styled.img`
  margin-top: 20px;
  width: 100%;
  max-width: 300px;
`;

const ConversionStatusLabel = styled.div`
  color: #999;
  font-size: 0.9rem;
`;

const RelativeDiv = styled.div`
  position: relative;
`;
